var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgIcSubscriptionStars = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 142,
  height: 120,
  fill: "none",
  viewBox: "0 0 142 120",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillOpacity: 0.24,
  d: "m-8.653 130.285 13.085-.893 8.12 10.294 3.204-12.723 12.293-4.564-11.082-7.002-.548-13.132-10.07 8.431-12.61-3.543L-1.4 119.34z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillOpacity: 0.16,
  d: "m.327 4.371 12.246 2.296 5.016 11.4 5.977-10.938L35.958 5.86l-8.524-9.078 2.623-12.207-11.268 5.355-10.753-6.262L9.605-3.967z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillOpacity: 0.24,
  d: "m107.087 25.766 11.798-14.207 18.38 1.72-9.858-15.623 7.287-16.964-17.901 4.497-13.92-12.195-1.185 18.453L85.828.862l17.146 6.879z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillOpacity: 0.16,
  d: "m94.133 131.895 16.423-4.292 12.808 11.13 1.004-16.951 14.531-8.768-15.781-6.229-3.866-16.567-10.769 13.15-16.89-1.463 9.123 14.323z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcSubscriptionStars);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };